import styled from 'styled-components';
import { isDiscounted } from '~/lib/utils';
import { Product } from '~/types/product';
import { fontFamilies } from '~/theme/typography';
import { FREE_PRICE_LABEL } from '~/common/utils/currency';

export const ProductPrice = ({ product }: { product: Product }) => {
  if (isDiscounted(product.prices)) {
    const discountedPrice = Number(product.prices.maxPrice);
    const originalPrice = Number(product.prices.compareAtPriceRange?.maxPrice);

    return (
      <PriceWrapper>
        <DiscountedPrice>
          {discountedPrice === 0
            ? FREE_PRICE_LABEL
            : discountedPrice?.toFixed(2) || ''}{' '}
        </DiscountedPrice>
        <OriginalPrice>{originalPrice?.toFixed(2) || ''}</OriginalPrice>
      </PriceWrapper>
    );
  }

  const defaultPrice = Number(product.prices.maxPrice);

  return (
    <DefaultPrice>
      {defaultPrice ? defaultPrice?.toFixed(2) || '' : FREE_PRICE_LABEL}
    </DefaultPrice>
  );
};

const priceStyles = `
  font-family: ${fontFamilies.PantonRustHeavy};
  font-size: 1rem;
  font-style: normal;
  font-weight: 100;
  line-height: normal;
  letter-spacing: 0.03125rem;
`;

const OriginalPrice = styled.span`
  ${priceStyles}
  color: ${({ theme }) => theme.colors.colorSecondary} !important;
  position: relative;

  @media ${({ theme }) => theme.breakpoints.sm} {
    font-size: 0.75rem;
  }

  &:before {
    position: absolute;
    content: '';
    left: 0;
    top: 50%;
    right: 0;
    border-top: 0.09375rem solid;
    border-color: inherit;
    transform: translateY(-50%);
  }
`;

const DiscountedPrice = styled.span`
  ${priceStyles}
  color: ${({ theme }) => theme.colors.white};
  margin-right: 0.5rem;

  @media ${({ theme }) => theme.breakpoints.sm} {
    font-size: 0.75rem;
  }
`;

const DefaultPrice = styled.span`
  ${priceStyles}
  color: ${({ theme }) => theme.colors.white};

  @media ${({ theme }) => theme.breakpoints.sm} {
    font-size: 0.75rem;
  }
`;

const PriceWrapper = styled.span`
  display: flex;
  align-items: center;
`;
